import { render, staticRenderFns } from "./7.vue?vue&type=template&id=70013ca9&scoped=true"
var script = {}
import style0 from "./7.vue?vue&type=style&index=0&id=70013ca9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70013ca9",
  null
  
)

export default component.exports